const lightbox  = document.getElementById('lightbox');
const closeLightbox = document.getElementById('closeLightbox');

// disable/enable scrolling
function disableScroll() {

    // Get the current page scroll position
    let scrollTop   = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft  = window.pageXOffset || document.documentElement.scrollLeft;

    // if any scroll is attempted, set this to the previous value
    window.onscroll = function () {
        window.scrollTo(scrollLeft, scrollTop);
    };
}

function enableScroll() {
    window.onscroll = function () {};
}

// Open the Modal
// eslint-disable-next-line no-unused-vars
function openModal() {
    lightbox.style.display = 'block';
    disableScroll();
}

if (closeLightbox != null) {
    closeLightbox.onclick = function () {
        lightbox.style.display = 'none';
        enableScroll();
    };
} 

var slideIndex = 1;
showSlides(slideIndex);

// Next/previous controls
// eslint-disable-next-line no-unused-vars
function plusSlides(n) {
    showSlides(slideIndex += n);
}

// eslint-disable-next-line no-unused-vars
function currentSlide(n) {
    showSlides(slideIndex = n);
}

function showSlides(n) {

    if (document.querySelector('.artwork') != null) {
        var i;
        var slides = document.getElementsByClassName('artwork');

        if (n > slides.length) {
            slideIndex = 1;
        }
        if (n < 1) {
            slideIndex = slides.length;
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].classList.remove('artwork--active');
        }
        slides[slideIndex - 1].classList.add('artwork--active');
    }
} 